import React from 'react';
import type { PropsWithChildren } from 'react';

import { PdfSectionCard, PdfSectionLabel } from './PdfExport.styles';

interface PdfSectionProps {
  /** Section header rendered in uppercase small-caps above the content. */
  label: string;
}

/**
 * A labelled card that groups related PDF content.
 * Avoids page breaks inside via `break-inside: avoid`.
 */
export default function PdfSection({
  label,
  children,
}: PropsWithChildren<PdfSectionProps>) {
  return (
    <PdfSectionCard>
      <PdfSectionLabel>{label}</PdfSectionLabel>
      {children}
    </PdfSectionCard>
  );
}
